module.exports = __webpack_public_path__ + "static/media/激光切割风火轮.0ec7934a.png";